import React, { useEffect, useState } from "react";
import './letters.css';
import nextLetter from './markovConsts.js';

//Un truc avec des chaine de markov

const LetterGridPage = () => {
  const sizeGap = 50;
  const firstLetter = "abcdefghijklmnopqrstuvwxyz"[Math.floor(Math.random() * 26)];

  const [size, setSize] = useState({
    width: Math.ceil(window.innerWidth/sizeGap),
    height: Math.ceil(window.innerHeight/sizeGap)
  });
  const [lastLetterId, setLastLetterId] = useState(0);
  const [backgroundLetters, setBackgroundLetters] = useState("a".split(""));

  const idToCoord = (id) => {
    return {x : id % size.width, y : Math.floor(id / size.width)};
  }

  const coordToId = (coord) => {
    return coord.y * size.width + coord.x;
  }

  const freeSpotsAround = (coord, background) => {
    let returnList = [];

    for(let i = -1; i <= 1; i++){
      for(let j = -1; j <= 1; j++){
        if(coord.x + i > 0 && coord.x + i <= size.width ){
          if(coord.y + j > 0 && coord.y + j <= size.height || i !== 0 && j !== 0){
            if(background[coordToId({x : coord.x + i, y: coord.y + j})] === " "){
              returnList.push(coordToId({x : coord.x + i, y: coord.y + j}));
            }
          }
        }
      }
    }
    return returnList;
  }

  const newPosition = (lastLetterId, background) => {
    let freeSpots = [];
    let cmptSafety = 0;
    while(freeSpots.length === 0 && cmptSafety < 20){//TODO : still infinite loop here
      cmptSafety++;
      let lastCoord = idToCoord(lastLetterId);
      freeSpots = freeSpotsAround(lastCoord, background);
      if(freeSpots.length > 0){
        return freeSpots[Math.floor(Math.random() * freeSpots.length)];
      }
      else{
        let tmp = background.map((c, index) =>  c !== " " ? index : null).filter((a) => a !== null);
        lastLetterId = tmp[Math.floor(Math.random() * tmp.length)];
      }
    }
    return null;
  }

  useEffect(() => {
    let tmpBackground = " ".repeat(size.width * size.height).split('');
    let tmpLetterId = Math.floor(Math.random() * size.width * size.height);

    tmpBackground[tmpLetterId]= firstLetter;

    setLastLetterId(tmpLetterId);
    setBackgroundLetters(tmpBackground);

    const timer = setInterval(() => {
      if(tmpBackground.filter(c => c === ' ').length === 0){
        tmpBackground = " ".repeat(size.width * size.height).split('');
      }
      tmpLetterId = newPosition(tmpLetterId, tmpBackground);
      tmpBackground[tmpLetterId] = nextLetter(backgroundLetters[lastLetterId]);
      setLastLetterId(tmpLetterId);
      setBackgroundLetters(tmpBackground);
    }, 2000);

    return () => clearInterval(timer);
  }, [])

//Horizontal 29
//Vert 15
  return (
    <div className="letter-grid">
        {backgroundLetters.map((letter, index) => (
          <div key={index} className="letter">
            {letter}
          </div>
        ))}
    </div>
  );
};

export default LetterGridPage;
